import Box from "@mui/material/Box";
import GlobalStyles from "@mui/material/GlobalStyles";
import { DEV_BANNER_HEIGHT_VAR } from "@/app/layout.utils";

const BANNER_HEIGHT_PX = 4;

const toDevEnvironmentColor = (mode: string): string => {
  if (mode === "prod") return "error.main";
  if (mode === "test") return "warning.main";
  return "grey.500";
};

/**
 * A thin coloured line across the top, only on the local dev server, showing which backend the UI
 * talks to: red for prod mode, amber for test, grey for a local backend. Sets --dev-banner-height.
 */
export const DevEnvironmentBanner = () => {
  if (!import.meta.env.DEV) return null;
  const color = toDevEnvironmentColor(import.meta.env.MODE);

  return (
    <>
      <GlobalStyles styles={{ ":root": { [DEV_BANNER_HEIGHT_VAR]: `${BANNER_HEIGHT_PX}px` } }} />
      <Box
        sx={{
          bgcolor: color,
          flexShrink: 0,
          height: BANNER_HEIGHT_PX,
        }}
      />
    </>
  );
};
